import { c as _c } from "react/compiler-runtime";
import type { Icon } from '@onefootprint/icons';
import type React from 'react';
import Button from '../button';
import Text from '../text';
type OnlyIcon = {
  iconComponent: Icon;
  renderHeader?: never;
};
type OnlyImage = {
  iconComponent?: never;
  renderHeader: () => React.ReactNode;
};
type NoIconOrImage = {
  iconComponent?: never;
  renderHeader?: never;
};
export type EmptyStateProps = {
  cta?: {
    label: string;
    onClick: () => void;
  };
  description: string;
  title: string;
  testID?: string;
} & (OnlyIcon | OnlyImage | NoIconOrImage);
const EmptyState = t0 => {
  const $ = _c(17);
  const {
    cta,
    description,
    iconComponent: Icon,
    renderHeader,
    title,
    testID
  } = t0;
  let t1;
  if ($[0] !== Icon) {
    t1 = Icon && <div className="mb-6"><Icon color="error" /></div>;
    $[0] = Icon;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== renderHeader) {
    t2 = renderHeader && <div className="mb-6">{renderHeader()}</div>;
    $[2] = renderHeader;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== title) {
    t3 = <Text variant="label-1" marginBottom={4}>{title}</Text>;
    $[4] = title;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== description) {
    t4 = <Text variant="body-2" color="secondary" textAlign="center">{description}</Text>;
    $[6] = description;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== cta) {
    t5 = cta && <div className="mt-8"><Button onClick={cta.onClick} variant="primary" size="large" fullWidth={true}>{cta.label}</Button></div>;
    $[8] = cta;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t1 || $[11] !== t2 || $[12] !== t3 || $[13] !== t4 || $[14] !== t5 || $[15] !== testID) {
    t6 = <div className="flex items-center justify-center flex-col" data-testid={testID}>{t1}{t2}{t3}{t4}{t5}</div>;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
    $[15] = testID;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
};
export default EmptyState;